import type { StripePortalDetailsData } from '../../repositories/stripe-account-repo/schemas/portail-details.zod';

export class StripePortalDetails {
  constructor(private readonly values: StripePortalDetailsData) {}

  public getId(): string {
    return this.values.id;
  }

  public getCustomer(): string {
    return this.values.customer;
  }

  public getPortalUrl(): string {
    return this.values.url;
  }

  public getReturnUrl(): string {
    return this.values.return_url;
  }

  public getConfigurationId(): string {
    return this.values.configuration;
  }

  public getCreatedTimestamp(): number {
    return this.values.created;
  }

  public getCreatedDate(): Date {
    return new Date(this.values.created * 1000);
  }

  public isLiveMode(): boolean {
    return this.values.livemode;
  }

  public getObject(): string {
    return this.values.object;
  }

  public getLocale(): string | null {
    return this.values.locale;
  }

  public getFlow(): string | null {
    return this.values.flow;
  }

  public getOnBehalfOf(): string | null {
    return this.values.on_behalf_of;
  }
}
